import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { InlineInputForm } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { useSetLoyaltyDetails } from '../../hooks/use-set-loyalty-details.js';
import 'uuid';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-w3c';

const CARD_NUMBER_VALIDATION_REG = new RegExp('^\\d{9}$');
const LoyaltyPointsInlineForm = ({ cartId , validation , cartHash  })=>{
    const { getLabel  } = useIntl();
    const { setLoyaltyCardNumber , isUpdating  } = useSetLoyaltyDetails();
    const labels = {
        actionLabel: getLabel('cart.loyalty.action.save'),
        inputPlaceHolder: getLabel('cart.loyalty.title'),
        inputError: getLabel('cart.loyalty.invalidNumber')
    };
    const [isFieldValid, setIsFieldValid] = React.useState(true);
    const isCardNumberValid = React.useCallback((inputValue)=>{
        var ref;
        if (validation) {
            setIsFieldValid(validation(inputValue.trim()));
            return validation(inputValue.trim());
        }
        if ((ref = CARD_NUMBER_VALIDATION_REG.exec(inputValue.trim())) === null || ref === void 0 ? void 0 : ref.length) {
            setIsFieldValid(true);
            return true;
        }
        setIsFieldValid(false);
        return false;
    }, [
        validation
    ]);
    const onInputChange = ()=>{
        if (!isFieldValid) {
            setIsFieldValid(true);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "loyalty-point__container"
    }, /*#__PURE__*/ React.createElement(InlineInputForm, {
        content: {
            inputField: {
                inputId: 'loyalty-point-number-input',
                type: 'text',
                validateInput: isCardNumberValid,
                onInputChange
            }
        },
        submitInProgress: isUpdating,
        onSubmit: (inputValue)=>setLoyaltyCardNumber(inputValue.trim(), cartId, cartHash)
        ,
        placeholderLabel: labels.inputPlaceHolder,
        buttonCaptionLabel: labels.actionLabel,
        "data-t": "loyalty-point-component-form"
    }), !isFieldValid && /*#__PURE__*/ React.createElement(Text, {
        className: "loyalty-point__error",
        variant: "caption"
    }, labels.inputError));
};

export { LoyaltyPointsInlineForm };
//# sourceMappingURL=LoyaltyPointsInlineForm.js.map
